import { useMutation, useQuery } from "@octopusdeploy/octopus-react-client";
import type { ModifyProcessCommand, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { isDeploymentProcessResource } from "@octopusdeploy/octopus-server-client";
import { useMemo } from "react";
import type { DeploymentProcessLoaderData } from "~/areas/projects/components/Process/DeploymentProcessPage";
import { getDeploymentProcess } from "~/areas/projects/components/Process/DeploymentProcessPage";
import { toDeploymentProcessIdentifier } from "~/areas/projects/components/Process/types";
export default function useDeploymentProcessState(project: ProjectResource, initialResult: DeploymentProcessLoaderData, gitRef: string | undefined) {
    const { result: deploymentProcessData, refetch: reloadDeploymentProcess } = useQuery((repository) => getDeploymentProcess(repository, project.SpaceId, project.Id, gitRef), [gitRef, project.SpaceId, project.Id], "Load deployment process", {
        initialResult,
    });
    const { execute: modifyDeploymentProcess } = useMutation({
        name: "Modify deployment process",
        action: (repository, process: ModifyProcessCommand, gitRef: string | undefined) => {
            if (isDeploymentProcessResource(process)) {
                return repository.DeploymentProcesses.modify(process, process.ProjectId, gitRef);
            }
            throw new Error("Attempted to modify a process that isn't a deployment process");
        },
        afterComplete: async () => reloadDeploymentProcess(),
    });
    const deploymentProcessIdentifier = useMemo(() => toDeploymentProcessIdentifier(project), [project]);
    return {
        deploymentProcessData,
        deploymentProcessIdentifier,
        reloadDeploymentProcess,
        modifyDeploymentProcess,
    };
}
